// File: src/ErrorFallback.tsx
import React from 'react'

interface Props {
  error: unknown
  resetErrorBoundary: () => void
}

export function ErrorFallback({ error, resetErrorBoundary }: Props) {
  return (
    <div style={{ padding: 20, fontFamily: 'sans-serif' }}>
      <h1>🚨 Something went wrong</h1>

      <details style={{ whiteSpace: 'pre-wrap', background: '#fee', padding: 10 }}>
        <summary>Error details</summary>
        {/* Print the error object */}
        <pre>
          {JSON.stringify(
            error,
            // include non‐enumerable props like message & stack
            Object.getOwnPropertyNames(error as object),
            2
          )}
        </pre>
        {/* Fallback in case error isn’t a plain object */}
        <pre>{error instanceof Error ? error.stack : String(error)}</pre>
      </details>

      <button onClick={resetErrorBoundary} style={{ marginTop: 20 }}>
        Try again
      </button>
    </div>
  )
}